import * as React from "react";
import s from "./ScoreGauge.module.scss";
import { Score, SeverityLabels } from "../../utils/types";
import { SvgCircle } from "./SvgCircle";

type ScoreGaugeProps = {
  score: Score;
  defaultProps?: any;
  circleProps?: any;
  bgCircleProps?: any;
};

export const ScoreGauge: React.FC<ScoreGaugeProps> = ({
  score,
  defaultProps = {},
  circleProps = {},
  bgCircleProps = {},
}) => {
  const dash = (-100 + score.score) * -1;

  const opacity = 1;
  const greyCircleOpacity = score.score < 10 ? 1 - 0.1 * score.score : 0;
  const viewbox = "0 0 50 40";
  const defaultCircle = {
    cx: "25",
    cy: "20",
    r: "16",
    rotate: "90deg",
    strokeWidth: "8px",
    fill: "none",
  };

  circleProps = { ...circleProps, strokeDasharray: `0 ${dash} 100 0`, opacity };
  bgCircleProps = { ...bgCircleProps, strokeDasharray: `0 0 100 0`, opacity };
  const greyCircleProps = {
    ...bgCircleProps,
    strokeDasharray: `0 0 100 0`,
    opacity: greyCircleOpacity,
  };

  const gradients = {
    [SeverityLabels.relativelyLow]: [
      { stopColor: "#2EF4AE", offset: "30%" },
      { stopColor: "#00D789", offset: "70%" },
    ],
    [SeverityLabels.significant]: [
      { stopColor: "#C3F160", offset: "30%" },
      { stopColor: "#2EF4AE", offset: "70%" },
    ],
    [SeverityLabels.high]: [
      { stopColor: "#FFD84E", offset: "30%" },
      { stopColor: "#FFEF61", offset: "70%" },
    ],
    [SeverityLabels.veryHigh]: [
      { stopColor: "#FF7918", offset: "30%" },
      { stopColor: "#FFD84E", offset: "70%" },
    ],
    [SeverityLabels.extreme]: [
      { stopColor: "#FF2F2F", offset: "30%" },
      { stopColor: "#FF7918", offset: "70%" },
    ],
    [SeverityLabels.more]: [{ stopColor: "#2EF4AE", offset: "70%" }],
  };

  const renderGradient = gradients[score.severity];

  return (
    <div className={s.gauge}>
      <div className={s.gaugeOverlay}>
        <span className={s.gaugeOverlayCount}>{score.score}</span>
      </div>
      <SvgCircle
        className={s.gaugeSvg}
        viewbox={viewbox}
        renderGradient={renderGradient}
        circleProps={{ ...defaultCircle, ...circleProps, ...defaultProps }}
      />
      <SvgCircle
        className={s.gaugeBgSvg}
        viewbox={viewbox}
        renderGradient={renderGradient}
        circleProps={{ ...defaultCircle }}
      />
      <SvgCircle
        className={s.gaugeBgSvg}
        viewbox={viewbox}
        renderGradient={[{ stopColor: "#cccccc", offset: "100%" }]}
        circleProps={{ ...defaultCircle, ...greyCircleProps }}
      />
    </div>
  );
};
